import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props?: { showDrawer: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      customersTableOuterBox: {
        flex: 'none',
        background: 'transparent',
        padding: '0px 40px',
        [theme.breakpoints.down('sm')]: {
          padding: '5px 20px 20px'
        }
      },
      customersTableContainer: {
        height: '700px',
        [theme.breakpoints.down('sm')]: {
          height: '790px'
        }
      },
      customersHeaderBlock: {
        padding: '24px 40px',
        justifyContent: 'space-between',
        background: 'transparent',
        display: 'flex',
        height: '100px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'row',
          gap: '20px'
        },
        [theme.breakpoints.only('sm')]: {
          padding: '18px 20px 18px 20px'
        },
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '18px 0px 18px 0px',
          height: '100%',
          margin: '20px'
        },
        [theme.breakpoints.down('sm')]: {
          height: '100px'
        }
      },
      customersHeading: {
        fontSize: '40px',
        lineHeight: '1',
        fontWeight: 600,
        letterSpacing: 'normal'
      },
      customersTableName: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600,
        paddingLeft: '24px'
      },
      customersTableActionHeaders: {
        lineHeight: '1.13',
        fontSize: '16px',
        fontWeight: 600,
        width: '160px',
        textAlign: 'center'
      },
      footer: {
        width: '100%',
        overflow: 'hidden',
        padding: '0px 40px',
        margin: 0
      },
      total: {
        float: 'right',
        fontSize: '20px',
        padding: '10px',
        fontWeight: 900,
        margin: 0
      },
      customerAddNewButton: {
        width: '175px',
        [theme.breakpoints.down('xs')]: {
          width: '175px',
          height: '41px'
        },
        [theme.breakpoints.only('md')]: {
          width: '175px',
          height: '45px'
        }
      },
      createClientInnerContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '524px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          width: '100%',
          padding: '0px 20px 0px 20px'
        }
      },
      createNewClientHeading: {
        fontWeight: 600,
        fontSize: '48px',
        textAlign: 'center',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '34px'
        }
      },
      saveButtonBox: {
        display: 'flex',
        alignItems: 'center',
        margin: '32px 0px',
        [theme.breakpoints.only('xs')]: {
          margin: '32px 0px'
        }
      },
      saveButton: {
        width: '200px',
        [theme.breakpoints.only('xs')]: {
          width: '150px'
        }
      },
      createClientName: {
        background: 'transparent',
        height: '130px',
        minWidth: '100%',
        [theme.breakpoints.down('xs')]: {
          height: '110px'
        },
        '& > * > * > input': {
          [theme.breakpoints.down('xs')]: {
            height: '40px'
          }
        }
      },
      customerContentBox: {
        flex: '1',
        background: 'transparent',
        padding: '32px 24px',
        width: '616px',
        '& > * > * > * > *': {
          [theme.breakpoints.down('xs')]: {
            whiteSpace: 'normal'
          }
        },
        [theme.breakpoints.only('xs')]: {
          padding: '8px'
        },
        [theme.breakpoints.up('md')]: {
          padding: '32px 56px'
        }
      },
      customerEditHeading: {
        fontSize: '32px',
        lineHeight: '1',
        letterSpacing: 'normal',
        margin: '0px'
      },
      customerEditOverlay: {
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.only('xs')]: {
          width: '300px'
        }
      },
      customerOverlayHeaderBlock: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        padding: '24px 24px 24px 24px',
        [theme.breakpoints.only('xs')]: {
          alignItems: 'flex-start',
          flexDirection: 'column-reverse',
          padding: '8px'
        }
      },
      customerOverlayHeading: {
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          paddingTop: '10px',
          paddingLeft: '20px'
        }
      },
      customerOverlayCloseIcon: {
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        [theme.breakpoints.only('xs')]: {
          justifyContent: 'flex-end',
          width: '100%'
        },
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px'
          }
        }
      },
      customerDeleteHeading: {
        flex: 'none',
        width: '600px',
        background: 'transparent',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('sm')]: {
          width: '490px',
          padding: '0px 20px 0px 0px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px'
        }
      },
      customerDeleteHeader: {
        textAlign: 'center',
        fontSize: '42px',
        margin: '0px',
        [theme.breakpoints.only('sm')]: {
          fontSize: '35px'
        },
        [theme.breakpoints.only('xs')]: {
          fontSize: '25px'
        }
      },
      customerDeleteDescription: {
        flex: 'none',
        background: 'transparent',
        [theme.breakpoints.only('sm')]: {
          width: '360px',
          padding: '0px 10px 0px 10px'
        },
        [theme.breakpoints.only('xs')]: {
          width: '300px',
          padding: '0px 10px 0px 10px'
        }
      },
      customerDeleteDescriptionText: {
        justifyContent: 'center',
        fontSize: '24px',
        margin: '0px',
        [theme.breakpoints.only('xs')]: {
          fontSize: '20px',
          whiteSpace: 'normal'
        }
      },
      createClientErrorText: {
        fontSize: '16px',
        color: '#C40B0F !important',
        margin: '0px',
        [theme.breakpoints.down('xs')]: {
          paddingTop: '20px'
        }
      },
      createClientButtonBox: {
        background: 'transparent',
        margin: '32px 0px 0px 0px',
        [theme.breakpoints.down('xs')]: {
          margin: '22px 0px 0px 0px'
        }
      },
      createClientButton: {
        color: 'white !important',
        height: '69px!important',
        fontSize: '24px',
        fontWeight: 600,
        [theme.breakpoints.down('xs')]: {
          height: '40px',
          width: '100%'
        }
      },
      createNewCustomerContainer: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0px auto',
        padding: '0px 20px',
        maxWidth: '1440px',
        height: '100%',
        background: 'white',
        borderRadius: '32px 32px 0px 0px',
        [theme.breakpoints.only('xs')]: {
          padding: '0px 0px'
        }
      },
      createNewCustomerLogoBlock: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '32px 72px 32px 72px',
        margin: '0px 0px 24px 0px',
        [theme.breakpoints.only('xs')]: {
          padding: '32px 20px 0px 20px'
        }
      },
      createNewCustomerLogo: {
        '& > *': {
          [theme.breakpoints.only('xs')]: {
            height: '40px'
          }
        }
      },
      createNewCustomerCloseIcon: {
        color: 'rgb(42, 42, 42)',
        '& > * > *': {
          [theme.breakpoints.only('xs')]: {
            width: '30px',
            height: '30px'
          }
        }
      },
      selectedRow: {
        borderWidth: 0,
        borderLeftWidth: 20,
        borderColor: 'black',
        borderStyle: 'solid',
        backgroundColor: 'white'
      },
      actionIconsBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        [theme.breakpoints.down('lg')]: {
          width: '160px'
        }
      },
      body: {
        overflow: props && props.showDrawer ? 'hidden' : 'auto'
      }
    })
  );
